import { typeOfPAF } from "../constants/typeOfPAF";

/**
 * Mirrors the "Maximum number of weeks exceeded" check in Patient Initiation (state 5).
 */
export function isMaxWeeksExceededPatientInitiation(registerPatient, prescriptionField) {
  const scheduleDisplayType = prescriptionField?.schedule_display_type;
  const isWeekSchedule =
    scheduleDisplayType === "weeks" ||
    scheduleDisplayType === "weeks_per_cycle";

  const weeksValue =
    scheduleDisplayType === "weeks_per_cycle"
      ? registerPatient?.total_weeks_supply
      : registerPatient?.other
        ? registerPatient?.other
        : registerPatient?.number_weeks?.id;

  const maxWeeks =
    typeOfPAF.WOMANOFCP === registerPatient?.type
      ? prescriptionField?.max_weeks_wcbp
      : prescriptionField?.max_weeks_m_or_wncbp;

  return (
    isWeekSchedule &&
    maxWeeks != null &&
    maxWeeks !== "" &&
    weeksValue != null &&
    weeksValue !== "" &&
    Number(weeksValue) > Number(maxWeeks)
  );
}

/**
 * Mirrors the max-capsules check when schedule_display_type === "weeks" (Patient Initiation state 5).
 */
export function isMaxCapsulesExceededPatientInitiationWeeksSchedule(
  registerPatient,
  prescriptionField
) {
  if (prescriptionField?.schedule_display_type !== "weeks") {
    return false;
  }
  const hasMax =
    typeOfPAF.WOMANOFCP === registerPatient?.type
      ? !!prescriptionField.max_capsules_wcbp
      : !!prescriptionField.max_capsules_m_or_wncbp;
  if (!hasMax) {
    return false;
  }
  const total =
    registerPatient.total_capsules !== 0
      ? registerPatient.total_capsules
      : registerPatient.capsule_strength;
  if (total == null || total === "") {
    return false;
  }
  const maxCap =
    typeOfPAF.WOMANOFCP === registerPatient?.type
      ? prescriptionField.max_capsules_wcbp
      : prescriptionField.max_capsules_m_or_wncbp;
  return Number(total) > Number(maxCap);
}
